import { TextField } from "@mui/material";
import NumberFormat from "react-number-format";

export const MyNumberField = (props) => {
  return (
    <NumberFormat
      //
      hidden={props.hidden}
      autoComplete={props.autoComplete ?? "off"}
      size={props.size ? props.size : "medium"}
      customInput={TextField}
      name={props.name}
      format={props.format}
      mask="_"
      style={{ width: "100%", margin: "1rem 0", ...props.style }}
      helperText={props.helperText}
      error={props.helperText !== "" && props.helperText !== null && props.helperText !== undefined}
      value={props.value}
      decimalSeparator={props.decimalSeparator ? props.decimalSeparator : false}
      allowNegative={props.allowNegative ? props.allowNegative : false}
      variant="outlined"
      label={props.label}
      onChange={props.onChange}
      placeholder={props.placeholder}
      type={props.type}
      required={props.required}
      onKeyPress={props.onKeyPress}
    />
  );
};
